@if (badge) {
    <ng-container *msShowInEpcot="EntainUi">
        @if (badge.count > 1) {
            <span class="reward-token-badge-count">{{ getBadgeCount(badge.count) }}</span>
        }
        <div class="reward-token-badge" [ngClass]="badge.backgroundColor">
            <span class="reward-token-badge__icon" [ngClass]="badge.icon"></span>
            <span class="reward-token-badge__text">{{ badge.title || '-' }}</span>
        </div>
    </ng-container>
    <ng-container *msShowInEpcot="EpcotUi">
        <div class="reward-token-badge-container__row">
            <span class="linear-rewards-selector__icon--epcot linear-rewards-selector__icon--valid theme-success-i"></span>
            <span class="reward-token-badge__text--epcot">{{ badge.title || '-' }}</span>
            @if (badge.count > 1) {
                <span class="reward-token-badge__text-promo-count">({{ getBadgeCount(badge.count) }})</span>
            }
        </div>
    </ng-container>
}
